<h2 mat-dialog-title>Become a TeleGo Customer Portal Beta Tester!</h2>
<mat-dialog-content class="mat-typography">
  <h3>As a Beta Tester, your company will be among the first users to test out our new improvements and features before they are made available to all of our customers.</h3>

  <i>Please note that the beta version of the TeleGo Customer Portal will be made available to all users on your account.
    Features and functionality may vary from those of the current production Customer Portal.
    You can switch back to the production version of the TeleGo Customer Portal at any time.
    If you have any questions, please contact your <a class="btn-link" role="button" (click)="openSupportWidget()">Customer Success Manager</a></i>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="accent" [mat-dialog-close]="1" cdkFocusInitial>Become a Beta Tester</button>
</mat-dialog-actions>
